export function fileToBase64(fileToLoad: any): Promise<any> | any {
    return new Promise((res, rej) => {
        var fileReader = new FileReader();

        fileReader.onload = function(fileLoadedEvent) {
            var srcData = fileLoadedEvent.target?.result; // <--- data: base64
            res(srcData)
        }
        fileReader.readAsDataURL(fileToLoad);
    });
}